import { BankcardTicketsPartialStoreState, BANKCARD_TICKETS_STATE_KEY } from './bankcard-tickets.reducer';

export const getTransaction = (state: BankcardTicketsPartialStoreState) =>
    state[BANKCARD_TICKETS_STATE_KEY].transaction;

export const getError = (state: BankcardTicketsPartialStoreState) => state[BANKCARD_TICKETS_STATE_KEY].error;

export const getTicketsError = (state: BankcardTicketsPartialStoreState) =>
    state[BANKCARD_TICKETS_STATE_KEY].ticketsError;

export const getTickets = (state: BankcardTicketsPartialStoreState) => state[BANKCARD_TICKETS_STATE_KEY].tickets;

export const getTicketsLoading = (state: BankcardTicketsPartialStoreState) =>
    state[BANKCARD_TICKETS_STATE_KEY].ticketsLoading;

export const getHslTickets = (state: BankcardTicketsPartialStoreState) => state[BANKCARD_TICKETS_STATE_KEY].hslTickets;

export const getHslTicketsLoading = (state: BankcardTicketsPartialStoreState) =>
    state[BANKCARD_TICKETS_STATE_KEY].hslTicketsLoading;
export const getLoading = (state: BankcardTicketsPartialStoreState) => state[BANKCARD_TICKETS_STATE_KEY].loading;

export const getFeedbackSuccess = (state: BankcardTicketsPartialStoreState) =>
    state[BANKCARD_TICKETS_STATE_KEY].feedbackSuccess;
